import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectClientModalComponent } from './select-client-modal.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '../modules/material.module';
import { SelectClientModalService } from './select-client-modal.service';
import { SharedModule } from '../modules/shared.module';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    SharedModule,
  ],
  exports: [SelectClientModalComponent],
  entryComponents: [SelectClientModalComponent],
  declarations: [SelectClientModalComponent],
  providers: [SelectClientModalService]
})
export class SelectClientModalModule { }



// WEBPACK FOOTER //
// ./src/app/core/select-client-modal/select-client-modal.module.ts